module.exports = __webpack_public_path__ + "changelog-ea83368b0123e05008a2038a14b959cc.webp";